import React from 'react';
import { observer, inject } from 'mobx-react';
import { Panel, Row, Col, Button } from 'react-bootstrap';
import IssueList from './IssueList';
import AddIssue from './AddIssue';


@inject('issueStore')
@observer
export default class Issues extends React.Component {

    render() {
        return (<Panel>
            <Panel.Heading>
                   <Row>
                       <Col lg={10} > <h5>Issues</h5> </Col>
                       <Col lg={2} ><Button bsStyle="primary" onClick={()=>{this.props.issueStore.ToggleAddIssueModal();}} >Add Issue</Button></Col>
                   </Row>
            </Panel.Heading>
            <Panel.Body>
                <IssueList />
                <AddIssue />
            </Panel.Body>
        </Panel>);
    }
}


// WEBPACK FOOTER //
// ./src/components/Issues/index.js